import { QueryClient, type QueryClientConfig } from '@tanstack/react-query';

// v4 typings expose `cacheTime`; v5 renamed it to `gcTime`. The runtime
// (react-query 4.44) reads BOTH at the cache layer when forwarded as default
// options, so we keep `gcTime` as the source-of-truth name (forward-compatible
// with v5) and cast through `unknown` to bypass the v4 QueryObserverOptions
// shape until the catalog bumps. No runtime behavior change.
const defaultOptions = {
  queries: {
    staleTime: 30_000,
    gcTime: 5 * 60_000,
    retry: 1,
  },
} as unknown as QueryClientConfig['defaultOptions'];

export const queryClient = new QueryClient({ defaultOptions });
